import { faker } from '@faker-js/faker';
import { EventTimeline, EventType, Room, RoomType } from 'matrix-js-sdk/src/matrix';

export enum RoomAssignType {
  MANUAL = 'manual',
  AUTO = 'auto',
  SELF_ASSIGN = 'self-assign',
}

export type BreakoutRoom = {
  id: string;
  title: string;
  userIds?: string[];
};

export type BreakoutRoomsFormData = {
  roomCount: number;
  assignment: RoomAssignType;
  allowReturnToMain: boolean;
  timeLimit: number | null;
  displayTimeLeft?: boolean;
};

export const defaultBreakoutRoomFormValues = {
  roomCount: 1,
  assignment: RoomAssignType.SELF_ASSIGN,
  allowReturnToMain: false,
  timeLimit: null,
};

export type FakeMember = {
  name: string;
  userId: string;
};

export const allMainRoomParticipants = Array.from({ length: 5 }, () => ({
  name: faker.name.firstName(),
  userId: faker.string.uuid(),
}));

export const getUnassignedParticipants = (rooms: BreakoutRoom[], allParticipants: FakeMember[]) => {
  const assignedUserIds = rooms.flatMap((room) => room.userIds);

  return allParticipants.filter((participant) => !assignedUserIds.includes(participant.userId));
};

const getStateEvents = (room: Room, eventType: string) =>
  room.getLiveTimeline().getState(EventTimeline.FORWARDS)?.getStateEvents(eventType) || [];

//NOTE: Main rooms don't have EventType.SpaceParent events and have child rooms
export const isMainRoom = (room: Room): boolean => {
  if (room.getType() !== RoomType.Space) return false;

  const parentEvents = getStateEvents(room, EventType.SpaceParent);
  const childEvents = getStateEvents(room, EventType.SpaceChild);

  return parentEvents.length === 0 && childEvents.length > 0;
};

//NOTE: Breakout rooms have both parent(main) and child(chat) rooms
export const isBreakoutRoom = (room: Room): boolean => {
  if (isMainRoom(room)) return false;

  return getStateEvents(room, EventType.SpaceChild).length > 0;
};
